export default "__VITE_ASSET__CnFIzAaF__"